module.exports = __webpack_public_path__ + "static/media/chequeabot-sticker.1b27b512.png";